module.exports = __webpack_public_path__ + "static/media/signed-light.0f9da150.svg";